import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { TagsModalComponent } from '@shared/modals/tags-modal/tags-modal.component';

@Component({
  standalone: true,
  template: ``,
})
export class TsTableTagsEditor extends OnDestroyMixin implements ICellEditorAngularComp, OnInit {
  public tags: string[] = [];
  private _originalValue: string[] = [];
  params: any;

  @Output() update: EventEmitter<any> = new EventEmitter();

  constructor(private dialog: MatDialog) {
    super();
  }

  ngOnInit(): void {}

  agInit(params: ICellEditorParams): void {
    this.params = params;
    const tagList = params.data.tag_list;
    this.tags = tagList ? tagList.split(',').map((tag: string) => tag.trim()) : [];
    this._originalValue = [...this.tags];

    this.openTagsModal();
  }

  getValue(): string[] {
    return this.tags;
  }

  openTagsModal(): void {
    const dialogRef = this.dialog.open(TagsModalComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: {
        tags: this.tags,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(untilComponentDestroyed(this))
      .subscribe((result) => {
        if (result && result.tags) {
          this.tags = result.tags;
          this.onSave();
        }
      });
  }

  onSave() {
    const newValue = [...this.tags];

    if (JSON.stringify(this._originalValue) !== JSON.stringify(newValue)) {
      this.updateModel();
      this.update.emit({ [this.params.colDef.field]: this.tags });
    }
  }

  updateModel() {
    this.params.data.tag_list = this.tags;
    this._originalValue = [...this.tags];
  }
}
